import React, { ReactNode, VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Link from '@material-ui/core/Link';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// js codes
import { getLinkStyles } from '../utils';

const useStyles = makeStyles((theme) => ({
  listItemLink: getLinkStyles(theme, { color: theme.palette.common.white }),
  actionSecondary: {
    top: '47%',
  },
  arrowIcon: {
    fontSize: theme.typography.pxToRem(15),
  },
}));

interface Props {
  href: string;
  id: string;
  'data-turbolinks': boolean;
  children: ReactNode;
}
const DrawerListItem: VFC<Props> = ({
  href,
  children,
  ...linkProps
}: Props) => {
  const classes = useStyles();
  return (
    <ListItem
      button
      key={href}
      component={Link}
      href={href}
      {...linkProps}
      className={classes.listItemLink}
    >
      <ListItemText primary={children} />
      <ListItemSecondaryAction className={classes.actionSecondary}>
        <ArrowForwardIosIcon className={classes.arrowIcon} />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default DrawerListItem;
